import { m } from 'framer-motion';

import Badge from '@mui/material/Badge';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useResponsive } from 'src/hooks/use-responsive';

import Iconify from 'src/components/iconify';
import { varHover } from 'src/components/animate';

import { useWhatsNew } from 'src/sections/changelog/whats-new-context';

// ----------------------------------------------------------------------

// "What's new" in the top bar, on every page. A green dot shows while there are updates the seller has not
// seen; opening the page clears it.
export default function WhatsNewButton () {
  const router = useRouter();

  const mdUp = useResponsive('up', 'md');

  const { unseen } = useWhatsNew();

  const hasNews = unseen.length > 0;

  const label = hasNews ? "What's new: new updates" : "What's new";

  const icon = (
    <Badge variant="dot" color="success" invisible={!hasNews}>
      <Iconify icon="solar:stars-bold" width={mdUp ? 20 : 24} />
    </Badge>
  );

  const openPage = () => router.push(paths.changelog);

  if (mdUp) {
    return (
      <Button
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={openPage}
        aria-label={label}
        startIcon={icon}
        sx={{ color: 'text.secondary', fontWeight: 600, fontSize: '0.8125rem', px: 1.5, minWidth: 'auto' }}
      >
        What&apos;s new
      </Button>
    );
  }

  return (
    <IconButton
      component={m.button}
      whileTap="tap"
      whileHover="hover"
      variants={varHover(1.05)}
      onClick={openPage}
      aria-label={label}
      sx={{ width: 40, height: 40 }}
    >
      {icon}
    </IconButton>
  );
}
